import React from "react";
import {
  Box,
  Typography,
  Chip,
  Collapse
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import GroupsIcon from "@mui/icons-material/Groups";
import {
  CategoriaSection,
  CategoriaHeader,
  CategoryIconBox,
  theme
} from "../../styles/CategoriaStyles";
import { RepresentanteRowItem } from "./RepresentanteItem";
import JuntaDirectivaView from "./JuntaDirectivaView";
import { getCategoriaIcon } from "./IconHelper"; // ← IMPORT CORREGIDO
import { 
  getCategoriasDeAsociacion,
  getRepresentantesDeCategoria 
} from "../../utils/representanteUtils";


const CategoriaList = ({
  selectedAsociacion,
  representantes = [],
  categorias = [],
  departamentos = [],
  municipios = [],
  expandedCategorias,
  onToggleCategoria,
  vistaJuntaDirectiva,
  onVistaJuntaChange
}) => {
  // Si no hay asociación seleccionada, mostrar mensaje
  if (!selectedAsociacion) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <GroupsIcon sx={{ 
          fontSize: 80, 
          color: theme.palette.border.light, 
          mb: 2 
        }} />
        <Typography variant="h5" sx={{ 
          color: theme.palette.text.secondary, 
          fontWeight: 600, 
          mb: 2 
        }}>
          FONDO CAFETERO NACIONAL
        </Typography>
        <Typography variant="body1" sx={{ 
          color: theme.palette.text.secondary, 
          mb: 4, 
          maxWidth: 400, 
          mx: "auto" 
        }}>
          Selecciona una asociación del panel superior para explorar sus representantes por categorías.
        </Typography>
      </Box>
    );
  }

  const categoriasAsociacion = getCategoriasDeAsociacion(
    representantes, 
    categorias, 
    selectedAsociacion.cod_asociacion
  );

  // Si no hay categorías, mostrar mensaje
  if (categoriasAsociacion.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h6" sx={{ 
          color: theme.palette.text.secondary, 
          mb: 2 
        }}>
          No hay representantes asignados
        </Typography>
        <Typography variant="body2" sx={{ 
          color: theme.palette.text.secondary 
        }}>
          Esta asociación no tiene representantes registrados en el sistema.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ 
        fontWeight: 600, 
        color: theme.palette.primary.main, 
        mb: 4, 
        display: "flex", 
        alignItems: "center", 
        gap: 2, 
        padding: "16px 0", 
        borderBottom: `2px solid ${theme.palette.border.light}` 
      }}>
        <GroupsIcon />
        Categorías y Representantes
      </Typography>

      {categoriasAsociacion.map((categoriaInfo) => {
        if (!categoriaInfo) return null;
        
        const expandedKey = `${selectedAsociacion.cod_asociacion}-${categoriaInfo.Id}`;
        const isCategoriaExpanded = expandedCategorias[expandedKey];
        const representantesCategoria = getRepresentantesDeCategoria(
          representantes, 
          selectedAsociacion.cod_asociacion, 
          categoriaInfo.Id
        );
        const esJuntaDirectiva = categoriaInfo.Id === 4;

        return (
          <CategoriaSection key={categoriaInfo.Id}>
            {/* Header de Categoría */}
            <CategoriaHeader 
              onClick={() => onToggleCategoria(
                selectedAsociacion.cod_asociacion, 
                categoriaInfo.Id
              )}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <CategoryIconBox>
                  {getCategoriaIcon(categoriaInfo.Descripcion, 24, theme)}
                </CategoryIconBox>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {categoriaInfo.Descripcion}
                  </Typography>
                  <Typography variant="body2" sx={{ 
                    color: theme.palette.text.secondary 
                  }}>
                    {categoriaInfo.count} representantes
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Chip 
                  label={`${categoriaInfo.count} reps`} 
                  size="small" 
                  sx={{ 
                    backgroundColor: theme.palette.accent.light, 
                    color: theme.palette.primary.main, 
                    fontWeight: 600 
                  }} 
                />
                {isCategoriaExpanded ? (
                  <ExpandLessIcon sx={{ color: theme.palette.accent.main }} />
                ) : (
                  <ExpandMoreIcon sx={{ color: theme.palette.accent.main }} />
                )}
              </Box>
            </CategoriaHeader>

            {/* Contenido Expandible */}
            <Collapse in={isCategoriaExpanded} timeout={200}>
              {esJuntaDirectiva ? (
                // Vista especial para Junta Directiva
                <JuntaDirectivaView
                  representantes={representantesCategoria}
                  asociacion={selectedAsociacion}
                  departamentos={departamentos}
                  vistaJuntaDirectiva={vistaJuntaDirectiva}
                  onVistaChange={onVistaJuntaChange}
                />
              ) : (
                // Vista normal para otras categorías
                <Box>
                  {representantesCategoria.map((representante) => (
                    <RepresentanteRowItem
                      key={representante.cod_representante}
                      representante={representante}
                      categoria={categoriaInfo}
                      departamentos={departamentos}
                      municipios={municipios}
                    />
                  ))}
                </Box>
              )}
            </Collapse>
          </CategoriaSection>
        );
      })}
    </Box>
  );
};

export default CategoriaList;